/** biome-ignore-all lint/complexity/useSimpleNumberKeys: this rule would messup our color codes like 500_8 => 5008 */
import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #48A8A0, step up 8%, step down 11%
// https://www.tailwindshades.com/#color=175%2C40%2C47.05882352941176&step-up=8&step-down=11&hue-shift=0&name=keppel&base-stop=5&v=1&overrides=e30%3D
const primary = {
  lighter: '#D7E9CE',
  light: '#C0DCB2',
  main: '#649E48',
  dark: '#335125',
  darker: '#020402',
};

// https://www.tailwindshades.com/#color=144%2C40%2C47.05882352941176&step-up=8&step-down=11&hue-shift=0&name=ocean-green&base-stop=5&v=1&overrides=e30%3D
const success = {
  lighter: '#B4DFC5',
  light: '#7BC699',
  main: '#48A86E',
  dark: '#26593B',
  darker: '#163221',
};

// https://www.tailwindshades.com/#color=29.04255319148936%2C88.67924528301886%2C58.4313725490196&step-up=8&step-down=11&hue-shift=0&name=jaffa&base-stop=5&v=1&overrides=e30%3D
const warning = {
  lighter: '#FCE6D1',
  light: '#F8BC84',
  main: '#F39237',
  dark: '#E4760E',
  darker: '#7A3F07',
};

// Base color: #9AA7AC, step up 8%, step down 14%
// https://www.tailwindshades.com/#color=100%2C6%2C89&step-up=8&step-down=11&hue-shift=0&name=gray-nurse&base-stop=2&v=1&overrides=e30%3D
const grey = {
  100: '#F7F8F7',
  200: '#E3E4E2',
  300: '#C6C9C5',
  400: '#AAADA8',
  500: '#8E928B',
  600: '#72766F',
  700: '#565954',
  800: '#3A3C39',
  900: '#1E201E',
  500_8: alpha('#8E928B', 0.08),
  500_12: alpha('#8E928B', 0.12),
  500_16: alpha('#8E928B', 0.16),
  500_24: alpha('#8E928B', 0.24),
  500_32: alpha('#8E928B', 0.32),
  500_48: alpha('#8E928B', 0.48),
  500_56: alpha('#8E928B', 0.56),
  500_80: alpha('#8E928B', 0.8),
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    success,
    warning,
    grey,
    background: {
      default: '#0B3142',
    },
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    action: {
      hover: alpha(primary.main, 0.32), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: primary.light,
      menuActiveText: primary.darker,
      menuDefaultText: grey[200],
      menuHoverBg: alpha(primary.light, 0.32),
      menuHoverText: grey[200],
      menuSecondaryText: grey[300],
      searchHoverBorder: primary.light,
    },
  },
};
